<template>
  <section class="page-section">
    <!-- step -->
    <div class="page-step">
      <div class="page-step-content real">
        <div class="page-step-name flex-h">
          <div
            class="flex-a-i"
            :class="{ 'current-step': infoData.operationDisplay >= 1 }"
          >
            买家下单
          </div>
          <div
            class="flex-a-i"
            :class="{ 'current-step': infoData.operationDisplay >= 2 }"
          >
            买家付款
          </div>
          <div
            class="flex-a-i"
            :class="{ 'current-step': infoData.operationDisplay >= 3 }"
            v-if="infoData.refundStatus != 1"
          >
            卖家发货
          </div>
          <div
            class="flex-a-i"
            :class="{ 'current-step': infoData.operationDisplay == 4 }"
          >
            订单完成
          </div>
        </div>

        <div class="page-step-icon flex-h">
          <div class="step-icon-box flex-a-i">
            <div
              class="step-icon"
              :class="{ 'current-step': infoData.operationDisplay >= 1 }"
            >
              <i
                class="el-icon-check"
                v-if="infoData.operationDisplay >= 1"
              ></i>
            </div>
          </div>
          <div class="step-icon-box flex-a-i">
            <div
              class="step-icon"
              :class="{ 'current-step': infoData.operationDisplay >= 2 }"
            >
              <i
                class="el-icon-check"
                v-if="infoData.operationDisplay >= 2"
              ></i>
            </div>
          </div>
          <div class="step-icon-box flex-a-i" v-if="infoData.refundStatus != 1">
            <div
              class="step-icon"
              :class="{ 'current-step': infoData.operationDisplay >= 3 }"
            >
              <i
                class="el-icon-check"
                v-if="infoData.operationDisplay >= 3"
              ></i>
            </div>
          </div>
          <div class="step-icon-box flex-a-i">
            <div
              class="step-icon"
              :class="{ 'current-step': infoData.operationDisplay == 4 }"
            >
              <i
                class="el-icon-check"
                v-if="infoData.operationDisplay == 4"
              ></i>
            </div>
          </div>

          <div class="step-line-box flex-h">
            <div
              class="step-line flex-a-i"
              :class="{ 'current-step': infoData.operationDisplay >= 2 }"
            ></div>
            <div
              class="step-line flex-a-i"
              :class="{ 'current-step': infoData.operationDisplay >= 3 }"
              v-if="infoData.refundStatus != 1"
            ></div>
            <div
              class="step-line flex-a-i"
              :class="{ 'current-step': infoData.operationDisplay == 4 }"
            ></div>
          </div>
        </div>

        <div class="page-step-time flex-h">
          <div class="flex-a-i">{{ infoData.createDate }}</div>
          <div class="flex-a-i">{{ infoData.payTime }}</div>
          <div class="flex-a-i" v-if="infoData.refundStatus != 1">
            {{ infoData.deliverTime }}
          </div>
          <div class="flex-a-i" v-if="infoData.refundStatus != 1">
            {{ infoData.receiverTime }}
          </div>
          <div class="flex-a-i" v-if="infoData.refundStatus == 1">
            {{ infoData.refundTime }}
          </div>
        </div>
      </div>
    </div>

    <!-- info -->
    <el-form
      size="small"
      label-width="80px"
      class="content-form no-padding-bottom detail-content"
    >
      <div class="form-module">
        <div class="module-header">订单信息</div>
        <div class="detail-body">
          <div class="detail-item flex-h">
            <p class="title">订单号：</p>
            <p class="flex-a-i">{{ infoData.orderNo }}</p>
          </div>
          <div class="detail-item flex-h">
            <p class="title">订单状态：</p>
            <p class="flex-a-i">
              <span v-if="infoData.status == -1">已关闭</span>
              <span v-if="infoData.status == 0">待付款</span>
              <span v-if="infoData.status == 1">待发货</span>
              <span v-if="infoData.status == 2">已发货</span>
              <span v-if="infoData.status == 4">已完成</span>
              <span v-if="infoData.status == 9">退款中</span>
              <span v-if="infoData.status == 10">退款成功</span>
              <span v-if="infoData.status == 11">退款失败</span>
            </p>
          </div>
          <div class="detail-item flex-h">
            <p class="title">发货仓库：</p>
            <p class="flex-a-i">{{ infoData.warehouseName }}</p>
          </div>
          <div class="detail-item flex-h">
            <p class="title">支付单号：</p>
            <p class="flex-a-i">{{ infoData.transactionId }}</p>
          </div>
          <div class="detail-item flex-h">
            <p class="title">付款方式：</p>
            <p class="flex-a-i">
              <span v-if="infoData.payType == 1">微信支付</span>
            </p>
          </div>
          <div class="detail-item flex-h">
            <p class="title">支付时间：</p>
            <p class="flex-a-i">{{ infoData.payTime }}</p>
          </div>
          <div class="detail-item flex-h">
            <p class="title">配送方式：</p>
            <p class="flex-a-i">{{ infoData.deliverName }}</p>
          </div>
          <div class="detail-item flex-h">
            <p class="title">实名认证：</p>
            <p class="flex-a-i">
              {{ infoData.userName
              }}<template v-if="infoData.idCard"
                >, {{ infoData.idCard }}</template
              >
            </p>
          </div>
          <div class="detail-item flex-h">
            <p class="title">运单号：</p>
            <p class="flex-a-i">{{ infoData.deliverNo }}</p>
          </div>
          <div class="detail-item flex-h">
            <p class="title">收货信息：</p>
            <p class="flex-a-i">
              <span class="mr-20">{{ infoData.receiveInfo }}</span
              ><el-button
                type="text"
                size="small"
                style="padding: 0"
                @click="editInfo"
                v-if="infoData.operationDisplay < 3"
                >修改收货信息</el-button
              >
            </p>
          </div>
        </div>
      </div>
    </el-form>

    <!-- table -->
    <div class="table-region" v-if="infoData != {}">
      <!-- 自定义表格 -->
      <div class="custom-table">
        <div class="custom-table-header">
          <el-row :gutter="10">
            <el-col :span="6">
              <div class="table-cell">商品</div>
            </el-col>
            <el-col :span="2">
              <div class="table-cell">数量</div>
            </el-col>
            <el-col :span="2">
              <div class="table-cell">商品单价</div>
            </el-col>
            <el-col :span="2">
              <div class="table-cell">商品总价</div>
            </el-col>
            <el-col :span="2">
              <div class="table-cell">税费单价</div>
            </el-col>
            <el-col :span="2">
              <div class="table-cell">税费总价</div>
            </el-col>
            <el-col :span="3">
              <div class="table-cell">优惠券抵扣</div>
            </el-col>
            <el-col :span="3">
              <div class="table-cell">实付金额</div>
            </el-col>
            <el-col :span="2" align="right">
              <div class="table-cell">交易状态</div>
            </el-col>
          </el-row>
        </div>

        <div class="custom-table-body flex-h">
          <div style="flex: 2">
            <!-- order item -->
            <div v-for="(item, index) in infoData.itemList" :key="index">
              <div class="order-list-item" style="margin-top: 0">
                <div class="item-body">
                  <el-row :gutter="10">
                    <el-col :span="9">
                      <div class="table-cell">
                        <div
                          class="img-wrap"
                          style="height: auto; align-items: center"
                        >
                          <div class="img-box">
                            <img :src="item.url" />
                          </div>
                          <div style="flex: 1">
                            <span
                              class="text hover-link"
                              style="height: auto; margin-bottom: 10px"
                              @click="pageLinkToGoodsDetail(item)"
                              >{{ item.commodityName }}</span
                            >
                            <div
                              v-for="(it, index) in item.skuList"
                              :key="index"
                              style="margin-left: 10px"
                            >
                              <p>{{ it.name }}：{{ it.value }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="table-cell">
                        <p class="text">&nbsp;&nbsp;{{ item.num }}</p>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="table-cell">
                        <p class="text">￥{{ item.unitPrice || "-" }}</p>
                        <p class="text">₩{{ item.unitKoreaPrice || "-" }}</p>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="table-cell">
                        <p class="text">
                          ￥{{
                            item.unitPrice ? item.unitPrice * item.num : "-"
                          }}
                        </p>
                        <p class="text">
                          ₩{{
                            item.unitKoreaPrice
                              ? item.unitKoreaPrice * item.num
                              : "-"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="table-cell">
                        <p class="text">￥{{ item.ratePrice || "-" }}</p>
                        <p class="text">₩{{ item.rateKoreaPrice || "-" }}</p>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="table-cell">
                        <p class="text">
                          ￥{{
                            item.ratePrice ? item.ratePrice * item.num : "-"
                          }}
                        </p>
                        <p class="text">
                          ₩{{
                            item.rateKoreaPrice
                              ? item.rateKoreaPrice * item.num
                              : "-"
                          }}
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div
                class="item-comment"
                v-if="item.orderCommentDetailVo != null"
              >
                <div class="flex-h">
                  <div class="comment-first">
                    <p>{{ item.orderCommentDetailVo.comment }}</p>
                    <p class="mt-10">
                      <span class="comment-first-time">{{
                        item.orderCommentDetailVo.commentTime
                      }}</span
                      ><el-rate
                        v-model="item.orderCommentDetailVo.star"
                        disabled
                        class="comment-star"
                      ></el-rate>
                    </p>
                    <div
                      class="img-wrap mt-10"
                      v-if="item.orderCommentDetailVo.commentPics != null"
                    >
                      <div
                        class="img-box"
                        v-for="(it, index) in item.orderCommentDetailVo
                          .commentPics"
                        :key="index"
                      >
                        <img :src="it" />
                      </div>
                    </div>
                  </div>
                  <div class="comment-second flex-h">
                    <div
                      class="flex-h"
                      v-if="item.orderCommentDetailVo.appendContent != ''"
                    >
                      <div class="comment-second-day">
                        {{ item.orderCommentDetailVo.days }}追评：
                      </div>
                      <div class="comment-second-content flex-a-i">
                        <p>{{ item.orderCommentDetailVo.appendContent }}</p>
                        <p class="mt-10">
                          {{ item.orderCommentDetailVo.appendTime }}
                        </p>
                        <div
                          class="img-wrap mt-10"
                          v-if="
                            item.orderCommentDetailVo.appendCommentPics != null
                          "
                        >
                          <div
                            class="img-box"
                            v-for="(it, index) in item.orderCommentDetailVo
                              .appendCommentPics"
                            :key="index"
                          >
                            <img :src="it" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="comment-option">
                    <el-button
                      type="text"
                      size="small"
                      v-if="item.orderCommentDetailVo.feedback == ''"
                      @click="reply(item)"
                      >回复</el-button
                    >
                    <el-popover
                      placement="left"
                      width="180"
                      v-model="item.delShow"
                      popper-class="confirm-popover"
                    >
                      <p>是否删除？</p>
                      <div>
                        <el-button
                          size="small"
                          type="default"
                          plain
                          @click="item.delShow = false"
                          >取消</el-button
                        >
                        <el-button
                          size="small"
                          type="primary"
                          @click="del(item)"
                          :loading="delLoading"
                          >确定</el-button
                        >
                      </div>

                      <el-button size="small" type="text" slot="reference"
                        >删除</el-button
                      >
                    </el-popover>
                  </div>
                </div>
                <div
                  class="item-reply flex-h"
                  v-if="item.orderCommentDetailVo.feedback != ''"
                >
                  <div class="reply-title">商家回复：</div>
                  <div class="flex-a-i">
                    <p>{{ item.orderCommentDetailVo.feedback }}</p>
                    <p class="mt-10">
                      {{ item.orderCommentDetailVo.feedbackTime }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="flex: 1" class="table-statistics">
            <el-row :gutter="10">
              <el-col :span="9">
                <div class="table-cell">
                  ￥{{ infoData.couponPrice || "-" }}
                </div>
              </el-col>
              <el-col :span="9">
                <div class="table-cell">￥{{ infoData.actuallyPrice }}</div>
              </el-col>
              <el-col :span="6" align="right">
                <div class="table-cell">
                  <p class="text" style="line-height: 48px; padding-right: 5px">
                    <span v-if="infoData.status == -1">已关闭</span>
                    <span v-if="infoData.status == 0">待付款</span>
                    <span v-if="infoData.status == 1">待发货</span>
                    <span v-if="infoData.status == 2">已发货</span>
                    <span v-if="infoData.status == 4">已完成</span>
                    <span v-if="infoData.status == 9">退款中</span>
                    <span v-if="infoData.status == 10">退款成功</span>
                    <span v-if="infoData.status == 11">退款失败</span>
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div
          class="custom-table-footer"
          v-if="
            infoData.status == 9 ||
            infoData.status == 10 ||
            infoData.status == 11
          "
        >
          <!-- 退款 -->
          <div class="return">
            <div class="return-box flex-h">
              <div class="return-title">退款原因：</div>
              <div class="return-content flex-a-i">
                {{ infoData.refundReason }}
              </div>
              <div class="return-status">
                <span v-if="infoData.refundStatus == -1">退款不通过</span>
                <span v-if="infoData.refundStatus == 0">待审核</span>
                <span v-if="infoData.refundStatus == 1">审核通过</span>
              </div>
            </div>
            <div class="return-time">{{ infoData.refundTime }}</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="回复"
      :visible.sync="dialogShow"
      width="30%"
      class="reply-dialog"
    >
      <el-form
        size="small"
        ref="formDialog"
        :model="formDialog"
        label-width="0px"
        class="dialog-form"
        :rules="rules"
      >
        <el-form-item class="reply-textarea" prop="feedback">
          <el-input
            resize="none"
            maxlength="200"
            type="textarea"
            :rows="8"
            v-model="formDialog.feedback"
            placeholder="用礼貌的回复给买家留下一个美好的购物印像吧（不可少于5个字）"
            @input="watchReplyCount"
          ></el-input>
          <div class="reply-count">{{ formDialog.replyCount }}/200</div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="dialogShow = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="handleReply('formDialog')"
          :loading="formDialog.replyLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="修改收货信息"
      :visible.sync="dialogAdressShow"
      width="400px"
    >
      <el-form
        size="small"
        ref="formDialog"
        :model="formDialog"
        label-width="80px"
        class="dialog-form"
        :rules="rules"
      >
        <el-form-item label="所在省">
          <el-select
            style="width: 100%"
            v-model="formDialog.provinceId"
            placeholder="请选择"
            @change="selectProvince"
          >
            <el-option
              v-for="item in formDialog.provinceList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在市">
          <el-select
            style="width: 100%"
            v-model="formDialog.cityId"
            placeholder="请选择"
            @change="selectCity"
          >
            <el-option
              v-for="item in formDialog.cityList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在区">
          <el-select
            style="width: 100%"
            v-model="formDialog.countyId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in formDialog.countyList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input
            class="text-area"
            type="textarea"
            :rows="2"
            v-model="formDialog.addressDetail"
            resize="none"
          ></el-input>
        </el-form-item>
        <el-form-item label="收货人姓名">
          <el-input v-model="formDialog.name" size="small"></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="formDialog.mobile" size="small"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="dialogAdressShow = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="handleSave"
          :loading="formDialog.replyLoading"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>

<script>
import addrData from "../../../common/js/address";
import {
  orderDetail,
  commentReply,
  commentDelete,
  editReceiveInfo,
} from "../../../common/api";

export default {
  data() {
    return {
      id: this.$route.query.id || "", // 订单id
      pageLoading: false,
      infoData: {},
      dialogShow: false, // 回复弹窗
      dialogAdressShow: false, // 修改收货信息弹窗
      formDialog: {
        // 弹窗参数
        replyId: "", // 回复的id
        feedback: "", // 回复内容
        replyCount: 0, // 回复的字符长度
        replyLoading: false,

        provinceId: "", // 省id
        provinceList: this.cloneData(addrData).subList, // 省级列表
        cityId: "", // 市id
        cityList: [], // 市级列表
        countyId: "", // 区id
        countyList: [], // 区级列表
        addressDetail: "", // 详细地址
        name: "", // 收货人
        mobile: "", // 手机号
      },
      delLoading: false, // 删除评论loading
      rules: {
        feedback: [
          { required: true, message: "请输入回复内容", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    /**
     * [cloneData description] 深拷贝克隆地址数据源
     * @param  {[Object]} obj [description] 需要被克隆的对象
     * @return {[Object]}       [description] 深拷贝出的新的地址数据源
     */
    cloneData: function (obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    /**
     * [getData description] 获取数据
     * @return {[type]}     [description]
     */
    getData: function () {
      this.pageLoading = true;
      orderDetail({ id: this.id })
        .then((res) => {
          this.pageLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.infoData = data;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.pageLoading = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [reply description] 打开回复弹窗
     * @param  {[Object]} item [description] 要回复的对象
     * @return {[type]}          [description]
     */
    reply: function (item) {
      this.formDialog.feedback = "";
      this.formDialog.replyId = item.orderCommentDetailVo.id;
      this.dialogShow = true;
    },
    /**
     * [watchReplyCount description] 监听输入字数
     * @param  {[String]} val [description] 输入框内的值
     * @return {[type]}          [description]
     */
    watchReplyCount: function (val) {
      this.formDialog.replyCount = val.split("").length;
    },
    /**
     * [handleReply description] 确定回复
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    handleReply: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formDialog.replyLoading = true;

          let param = {
            id: this.formDialog.replyId,
            feedback: this.formDialog.feedback,
          };

          commentReply(param)
            .then((res) => {
              this.formDialog.replyLoading = false;

              let { code, data, msg } = res;

              if (code == 0) {
                this.dialogShow = false;
                this.$message.success("回复成功");
                this.getData();
              } else {
                this.$message.error(msg);
              }
            })
            .catch((error) => {
              this.formDialog.replyLoading = false;
              this.dialogShow = false;
              this.$message.error("服务器异常");
            });
        } else {
          return false;
        }
      });
    },
    /**
     * [del description] 删除评价
     * @param  {[Object]} item [description] 删除列对象
     * @return {[type]}        [description]
     */
    del: function (item) {
      this.delLoading = true;

      let param = {
        id: item.orderCommentDetailVo.id,
      };

      commentDelete(param)
        .then((res) => {
          this.delLoading = false;
          item.delShow = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.$message.success("删除成功");
            this.getData();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          item.delShow = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [editInfo description] 打开修改收货信息弹窗
     * @return {[type]}        [description]
     */
    editInfo: function () {
      this.formDialog.provinceId = this.infoData.provinceId;
      for (let i in this.formDialog.provinceList) {
        if (
          this.formDialog.provinceList[i].code == this.formDialog.provinceId
        ) {
          this.formDialog.cityList = this.formDialog.provinceList[i].subList;
          this.formDialog.cityId = this.infoData.cityId;
          for (let j in this.formDialog.cityList) {
            if (this.formDialog.cityList[j].code == this.formDialog.cityId) {
              this.formDialog.countyList = this.formDialog.cityList[j].subList;
              this.formDialog.countyId = this.infoData.countyId;
              break;
            }
          }
        }
      }

      this.formDialog.addressDetail = this.infoData.address;
      this.formDialog.name = this.infoData.receiverName;
      this.formDialog.mobile = this.infoData.receiverPhone;

      this.dialogAdressShow = true;
    },
    /**
     * [selectProvince description] 选择所在省
     * @return {[type]}        [description]
     */
    selectProvince: function () {
      this.formDialog.countyId = "";
      this.formDialog.countyList = [];
      this.formDialog.cityId = "";
      this.formDialog.cityList = [];

      for (let i in this.formDialog.provinceList) {
        if (
          this.formDialog.provinceList[i].code == this.formDialog.provinceId
        ) {
          this.formDialog.cityList = this.formDialog.provinceList[i].subList;
        }
      }
    },
    /**
     * [selectCity description] 选择所在市
     * @return {[type]}        [description]
     */
    selectCity: function () {
      this.formDialog.countyId = "";
      this.formDialog.countyList = [];

      for (let i in this.formDialog.cityList) {
        if (this.formDialog.cityList[i].code == this.formDialog.cityId) {
          this.formDialog.countyList = this.formDialog.cityList[i].subList;
        }
      }
    },
    /**
     * [handleSave description] 保存收货地址
     * @return {[type]}        [description]
     */
    handleSave: function () {
      this.formDialog.replyLoading = true;

      let param = {
        userId: this.infoData.userId,
        orderId: this.id,
        name: this.formDialog.name,
        mobile: this.formDialog.mobile,
        provinceId: this.formDialog.provinceId,
        cityId: this.formDialog.cityId,
        countyId: this.formDialog.countyId,
        addressDetail: this.formDialog.addressDetail,
        beDefault: 0,
      };

      editReceiveInfo(param)
        .then((res) => {
          this.formDialog.replyLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.dialogAdressShow = false;
            this.$message.success("保存成功");
            this.getData();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.formDialog.replyLoading = false;
          this.dialogAdressShow = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [pageLinkToGoodsDetail description] 查看商品详情
     * @param  {[Object]} item [description] 操作列对象
     * @return {[type]}        [description]
     */
    pageLinkToGoodsDetail: function (item) {
      this.$router.push({
        path: "/goods/manage/add",
        query: { id: item.commodityId },
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.table-statistics {
  border: 1px solid $separateDefaultColor;
  border-left: none;

  ::v-deep .el-row {
    padding: 0;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

.hover-link {
  color: $themeColor !important;
  cursor: pointer;

  &:hover {
    color: $darkLinkHoverColor !important;
  }
}

.mr-20 {
  margin-right: 20px;
}

.mt-10 {
  margin-top: 10px;
}

.reply-dialog {
  ::v-deep .el-dialog {
    min-width: 400px !important;
  }

  .reply-textarea {
    position: relative;

    .reply-count {
      position: absolute;
      right: 15px;
      bottom: 5px;
      line-height: 18px;
      color: $tipsDisabledColor;
    }
  }
}

.text-area {
  ::v-deep .el-textarea__inner {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}

.page-step {
  padding: 20px 0;
  background: $colorPageBg;
  font-size: $smallFS;
  color: $textColor;

  .page-step-content {
    margin: 0 auto;
    text-align: center;

    &.real {
      width: 760px;

      .step-line-box {
        width: 570px;
      }
    }

    &.virtual {
      width: 560px;

      .step-line-box {
        width: 370px;
      }
    }

    .page-step-name {
      margin-bottom: 10px;

      .current-step {
        color: #3ec1da;
      }
    }

    .page-step-icon {
      position: relative;
      margin-bottom: 10px;

      .step-icon-box {
        .step-icon {
          @include position(relative, 1, none, none, none, none);
          margin: 0 auto;
          width: 24px;
          height: 24px;
          border-radius: 12px;
          background: $borderDefaultColor;

          &.current-step {
            background: #5bcfe6;
          }

          i {
            font-size: 16px;
            line-height: 24px;
            text-align: center;
            color: #ffffff;
          }
        }
      }

      .step-line-box {
        @include position(absolute, 0, 50%, none, none, 50%);
        @include translate(-50%, -50%, 0);
        height: 3px;

        .step-line {
          background: $borderDefaultColor;

          &.current-step {
            background: #5bcfe6;
          }
        }
      }
    }
  }
}

.detail-content {
  color: $textColor;

  .detail-body {
    padding-top: 20px;
    font-size: $smallFS;

    .detail-item {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        width: 150px;
        text-align: right;
      }
    }
  }
}

.table-region {
  .custom-table {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .custom-table-header {
      flex-shrink: 0;
      padding-right: 4px;
      text-align: center;
      scrollbar-gutter: stable;

      .table-cell {
        text-align: left;
      }
    }

    .custom-table-body {
      flex: 1;
      padding-right: 4px;
      overflow-y: overlay;
    }
  }

  .custom-table-footer {
    padding: 10px;
    font-size: $smallFS;

    .return-box {
      .return-title,
      .return-content {
        color: $textColor;
      }

      .return-status {
        flex: 0 0 30%;
        width: 30%;
        text-align: right;
        color: $compeleteColor;
      }
    }

    .return-time {
      margin-top: 10px;
      margin-left: 60px;
      color: $textColor;
    }
  }
}

.item-comment {
  padding: 10px;
  border: 1px solid $separateDefaultColor;
  border-top: none;
  font-size: $smallFS;

  .comment-first,
  .comment-second {
    flex: 0 0 45%;
    width: 45%;

    .img-wrap {
      @include alignItems(center);

      .img-box {
        display: inline-block;
        position: relative;
        width: 48px;
        height: 48px;
        background: $colorImgBg;

        & + .img-box {
          margin-left: 10px;
        }

        img {
          @include position(absolute, 1, 50%, none, none, 50%);
          max-width: 100%;
          max-height: 100%;
          @include translate(-50%, -50%, 0);
        }
      }
    }
  }

  .comment-first {
    .comment-first-time {
      display: inline-block;
      vertical-align: middle;
    }

    .comment-star {
      display: inline-block;
      margin-left: 20px;
    }
  }

  .comment-second {
    padding-left: 5px;

    .comment-second-day {
      color: $tipsColor;
    }
  }

  .comment-option {
    flex: 0 0 10%;
    width: 10%;
    text-align: right;
  }

  .item-reply {
    margin-top: 10px;

    .reply-title {
      color: $compeleteColor;
    }
  }
}
</style>
